
export function InputField({ label, name, type, register, error }) {
    return (
  <div className="mb-4">
    <label htmlFor={name} className="block text-sm font-medium text-gray-700">{label}</label>
    <input
      id={name}
      type={type}
      {...register(name)}
      className={`mt-1 block w-full px-3 py-2 border ${error ? 'border-red-500' : 'border-gray-300'} rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm`}
      placeholder={label}
    />
    {error && <p className="mt-1 text-sm text-red-600">{error.message}</p>}
  </div>
);
}
